import { CMSAllocation } from "@components/V2/Vault/Common/VaultAprReports";
import { ReactNode, createContext } from "react";

interface IData {
  cmsAllocations: {
    allocations: CMSAllocation[];
  } | null;
}

const initialData: IData = {
  cmsAllocations: null,
};

export const StableVaultPageContext = createContext(initialData);

interface IProps {
  children: ReactNode;
  data: IData;
}

export const StableVaultProider = ({ data, children }: IProps) => {
  return (
    <StableVaultPageContext.Provider value={data}>
      {children}
    </StableVaultPageContext.Provider>
  );
};

export { type IData as PageContextData };
